import React from 'react';
import styled from 'styled-components';
import Color from '../../styles/Color';

const Button = styled.div`
  cursor: pointer;
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: ${props => props.width ? props.width + 'px' : 200 + 'px'};
  height: 40px;
  background-color: ${props => props.bgColor ? props.bgColor : Color.subColor300};
  border-radius: 40px;
  padding: 0 15px;
  &:hover {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    font-weight: 600;
    & > .coming {
      display: flex;
    }
  }
  & > a {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    
    & > img {
      margin-left: 10px;
    }
    & > p {
      margin-left: ${props => props.img ? '10px' : 'auto'};
      font-weight: 400;
      font-size: ${props => props.fontSize ? props.fontSize : '17px'};
      color: #fff;
    }
    & > svg {
      margin-left: auto;
    }
  }
`
const Coming = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  border-radius: 40px;
  opacity: 0.7;
  display: none;
  justify-content: center;
  align-items: center;
  & > p {
    font-weight: 600;
    font-size: 15px;
    color: #fff;
  }
  @media (max-width: 1010px) {
    display: flex;
  };
`
const BasicButton = ({ style, text, color, width, bgColor, img, imgStyle, fontSize, onClick, href, coming = false }) => {
  return (
    <Button
      style={style}
      color={color}
      bgColor={bgColor}
      width={width}
      img={img}
      fontSize={fontSize}
      onClick={onClick}
    >
      <a target="_blank" href={href} rel="noreferrer" >
        {
          img && <img style={imgStyle} alt='' src={img} />
        }
        <p>{text}</p>
        <svg width="9" height="13" viewBox="0 0 9 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L7 6.5L1 12" stroke="white" stroke-width="1.5" />
        </svg>
      </a>
      {
        coming &&
        <Coming className="coming">
          <p>Coming soon</p>
        </Coming>
      }
    </Button>
  )
}
export default BasicButton;